module.exports = __webpack_public_path__ + "static/img/fish99.38a7c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish99.png
// module id = dKT1
// module chunks = 0